import React from 'react';
import PropTypes from 'prop-types';
import { CDN_SERVER_URL } from '@/constants/urls';
import { CARDS_TYPE } from '@/constants/account';

const url = `${CDN_SERVER_URL}/next/creditCardLogos`;

const CreditCardLogos = ({ brand, className, small = false }) => {
  const brandUpperCase = brand.toUpperCase();
  const logo = [
    CARDS_TYPE.AMERICAN_EXPRESS,
    CARDS_TYPE.MASTERCARD,
    CARDS_TYPE.VISA
  ].includes(brandUpperCase) ? brandUpperCase : CARDS_TYPE.DEFAULT;

  return (
    <img
      src={`${url}/${logo}.png`}
      alt={`${logo}-logo`}
      className={`${small ? 'cc-logos-img-sm' : 'cc-logos-img'}${className ? ' ' + className : ''}`}
    />
  );
};

CreditCardLogos.propTypes = {
  brand: PropTypes.string.isRequired,
  small: PropTypes.bool,
  className: PropTypes.string
};

export default React.memo(CreditCardLogos);
